import type {YMapFeatureProps} from "@yandex/ymaps3-types";

export default function getMapFeaturesCenter(geojson: YMapFeatureProps | YMapFeatureProps[]): [number, number] | null {

    const features = Array.isArray(geojson) ? geojson : [geojson]

    let totalCount = 0;
    let sumLongitude = 0;
    let sumLatitude = 0;

    // Обрабатываем объекты GeoJSON

    features.forEach(feature => {
        if (feature.geometry && feature.geometry.coordinates) {
            processCoordinates(feature.geometry.coordinates);
        }
    })

    function processCoordinates(coords: any[]): void {
        // Проверяем, является ли первый элемент массива числом (координата точки)
        if (typeof coords[0] === 'number') {
            const [longitude, latitude] = coords;
            sumLongitude += longitude;
            sumLatitude += latitude;
            totalCount++;
            return;
        }

        // Рекурсивно обрабатываем вложенные массивы
        if (Array.isArray(coords[0])) {
            coords.forEach((coordGroup: any[]) => {
                processCoordinates(coordGroup);
            });
        }
    }

    if (totalCount === 0) {
        return null
    }

    return [
        sumLongitude / totalCount,
        sumLatitude / totalCount
    ];
}
